export const M_TbmEntry_BASIC_Schema = {
  mapper: {
    search1: {
      UserId: (context) => context.userInfo?.userid ?? '',
    },
  },
};

/** 회의록 작업 장소 체크박스 항목(중복 선택 가능, '기타'는 수기 입력) */
export const WORK_LOCATIONS = ['F/D Yard', '안벽', '사무동', '샵장', '기타'];

/** 회의록 잠재위험요인 체크박스 항목(중복 선택 가능, '기타'는 수기 입력) */
export const HAZARD_TYPES = [
  '가연성',
  '폭발성',
  '질식성',
  '유독성',
  '부식성',
  '화학성',
  '감전',
  '고온',
  '고압',
  '소음',
  '분진',
  '협착',
  '충돌',
  '추락',
  '전도',
  '낙하물',
  '크레인/지게차',
  '환경오염',
  '기타',
];
